<template>
    <div>
        <content-loader v-if="$apollo.loading" title="Insight"/>
        <div v-else>
            <page-header :title="insightDetail.title" class="insight-banner"></page-header>
            <div class="container">
                <div class="wrapper">
                    <div class="insight-detail">
                       <div class="tag" v-if="insightDetail.tags">
                            <span class="badge" v-for="(tag, index) in insightDetail.tags" :key="index">{{ tag }}</span>
                        </div>
                        <div class="author">
                            <h6 v-if="insightDetail.authorId"><strong>{{ insightDetail.author.name }}</strong>{{ authorTitleCompanyName }}</h6>
                            <time>{{ insightDetail.publishedAt | moment('MMM DD')}} - {{ insightDetail.duration }}</time>
                        </div>
                        <div class="content">
                            <div class="text" v-html="insightDetail.content"></div>
                            <div v-if="insightDetail.mediaUrl" class="mt-4 embed-responsive embed-responsive-16by9 z-depth-1-half">
                                <iframe class="embed-responsive-item" :src="insightDetail.mediaUrl" allowfullscreen ></iframe>
                            </div>
                        </div>
                        <app-social-sharing class="share" :url="$route.path" :title="insightDetail.name"></app-social-sharing>
                    </div>
                    
                    <comments
                        :comments="insightDetail.comments"
                        @submit-comment="submitComment"
                        @delete-comment="deleteComment"
                    ></comments>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GetInsightDetail from '@/gql/GetInsightDetail.gql';
import InsertComment from '@/gql/InsertComment.gql';
import DeleteComment from '@/gql/DeleteComment.gql';

import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader';
import AppSocialSharing from '@/components/global/AppSocialSharing';
import Comments from '@/components/global/Comments';

export default {
    name: 'insight-detail',

    components: {
        PageHeader,
        ContentLoader,
        AppSocialSharing,
        Comments
    },

    apollo: {
        insightDetail: {
            query: GetInsightDetail,
            variables() {
                return {
                    id: this.$route.params.id
                }
            }
        }
    },

    data() {
        return {
            insightDetail: '',
        }
    },

    computed: {
        authorTitleCompanyName() {
            return this.insightDetail.author.companyName && ', ' + this.insightDetail.author.title + ' at '+ this.insightDetail.author.companyName;
        }
    },

    methods: {
        submitComment(comment, current_user) {
            this.$apollo.mutate({
                mutation: InsertComment,
                variables: {
                    insightId: this.$route.params.id,
                    authorId: current_user.id,
                    content: comment,
                    sourceType: 'INSIGHT',
                },
            }).then(({ data }) => {
                this.insightDetail.comments.unshift(data.insert_Comment.returning[0]);
            }).catch((err) => {
                alert(err.message);
            });
        },

        async deleteComment(id) {
            await this.$apollo.mutate({
                mutation: DeleteComment,
                variables: {
                    id: id,
                },
                update: (client, { data }) => {
                    this.insightDetail.comments.splice(this.insightDetail.comments.findIndex(comment => comment.id === id), 1);
                },
            }).catch((err) => {
                alert(err.message);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    .insight-banner {
        /deep/ .banner-content {
            max-width: 100%;
        }
    }
    .wrapper {
        padding: 20px 0 90px;
    }

    .insight-detail {
        background-color:#ffffff;
        padding: 30px;

        @include media-breakpoint-up(md) {
            padding: 40px 30px;
        }

        .tag {
            margin-bottom: 30px;
        }

        .embed-responsive {
            max-width: 500px;
            max-height: 337px;
            background: rgba(0, 1, 18, 0.05);
            border: 2px solid rgba(0, 1, 18, 0.05);
        }

        .author {
            font-size: 14px;
            margin-bottom: 15px;
            @include media-breakpoint-up(md) {
                margin-top: 20px;
            }
            @include media-breakpoint-up(lg) {
                margin-top: 0;
                margin-bottom: 30px;
            }
            h6 {
                margin-bottom: 3px;
            }

            time {
                color: $grey;
            }
        }

        .content {
            font-size: 15px;
            line-height: 24px;
            color: #505B64;
            margin-bottom: 20px;
            @include media-breakpoint-up(md) {
                font-size: 18px;
                line-height: 31px;
                margin-bottom: 40px;
            }

            .text /deep/ img {
                max-width: 100%;
            }
            .text /deep/ iframe {
                max-width: 100%;
            }
        }

        .share {
            margin-bottom: 30px;
            @include media-breakpoint-up(md) {
                margin-bottom: 50px;
            }
        }
    }
</style>
